import {
  usePartnerSessionCanAccessModule,
  usePartnerSessionCanEditModule,
  usePartnerSessionModuleDenied,
  usePartnerSessionModuleReadOnly,
} from "./usePartnerSessionPermissions";
import { PARTNER_PORTAL_PERMISSION_KEYS as PP_KEYS } from "../utils/permissions/partnerPortalPermissionKeys";

/** Partner portal Cart & Checkout (`cart_checkout`) permission helpers. */
export function useCartCheckoutPermissions() {
  const key = PP_KEYS.CART_CHECKOUT;
  const canAccess = usePartnerSessionCanAccessModule(key);
  const canEdit = usePartnerSessionCanEditModule(key);
  const readOnly = usePartnerSessionModuleReadOnly(key);
  const denied = usePartnerSessionModuleDenied(key);

  return {
    canAccess,
    canEdit,
    readOnly,
    denied,
    /** Cart purchase button visible (edit or view). */
    showCartButton: canAccess,
    /** Cart purchase button interactive. */
    cartButtonDisabled: !canEdit || readOnly,
  };
}
